import { Component } from '@angular/core'
import { PageTitleComponent } from '@appShared/components/page-title/page-title.component'

@Component({
    selector: 'app-support',
    imports: [PageTitleComponent],
    templateUrl: './support.component.html',
    styleUrl: './support.component.less'
})
export class SupportComponent {
}
